<div class="top-header-right-section flex align-items-center gap-5">
  <st-top-header-filters>
    <div ngProjectAs="filters-section">
      <ng-content select="top-filters-section"></ng-content>
    </div>
  </st-top-header-filters>
  <div class="notification-section">
    <ng-content select="notification-section"></ng-content>
  </div>
  
</div>
